<template>
    <button v-if="this.disabled == true || this.loader == true" :aria-busy="this.loader" :style='this.style' v-bind:class="this.type" disabled class='btn disabled btn-loadable'>
        <i v-if='this.icon_i' class='item-i mr-1' :class='this.icon_i' :style="this.showSpinner ? 'visibility:hidden' : ''"></i>
        <span :style="this.showSpinner ? 'visibility:hidden' : ''">{{this.name}}</span>
        <loading :active="this.showSpinner" :is-full-page="false" :height="22" :width="22" :loader="'spinner'" :color="'#008D3E'" :opacity="0" />
    </button>
    <button v-else class='btn' :style='this.style' v-bind:class="this.type">
        <i v-if="this.icon_i.length > 1" class='item-i mr-1' :class='this.icon_i'></i>
        {{this.name}}
    </button>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading },
    props: {
        name: [String],
        type: {
            type: String,
            default: 'btn-primary'
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        // Встроенный мелкий спиннер: кнопка крутит крутилку и блокируется,
        // пока идёт связанный запрос. Точечный аналог глобального оверлея.
        loader: {
            type: Boolean,
            default: false,
        },
        icon_i: {
            type: String,
            default: '',
        },
        style: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            // Спиннер показываем с задержкой 250мс (анти-мерцание),
            // а блокировку кнопки (disabled) — сразу, до таймера.
            showSpinner: false,
        }
    },
    watch: {
        loader: {
            // immediate: кнопка может смонтироваться, когда loader уже true.
            // _spinnerTimer держим лениво на инстансе (не в data — не реактивно).
            immediate: true,
            handler(val) {
                clearTimeout(this._spinnerTimer);
                if (val) {
                    this._spinnerTimer = setTimeout(() => { this.showSpinner = true; }, 250);
                } else {
                    this.showSpinner = false;
                }
            }
        }
    },
    beforeUnmount() {
        clearTimeout(this._spinnerTimer);
    },
}
</script>

<style lang="scss" scoped>
// Auth redesign — кнопки по макету Claude Design. Токены: includes/_auth-tokens.scss.
.btn {
    box-shadow: none;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 52px;
    padding: 0 24px;
    border: none;
    border-radius: var(--radius-field);
    font-family: 'HelveticaNeue', 'Roboto medium', sans-serif;
    font-size: 15.5px;
    font-weight: 600;
    transition: transform .12s ease, background-color .15s ease, box-shadow .15s ease, border-color .15s ease;
}
.btn:active:not(.disabled) { transform: translateY(1px); }
// Контейнер для точечного спиннера (vue-loading-overlay, is-full-page=false):
// overlay позиционируется absolute относительно кнопки.
.btn-loadable {
    position: relative;
}
.btn .item-i {
    height: 1.2em;
    width: 1.2em;
}

// --- primary (CTA) ---
.btn-warning {
    background-color: var(--accent);
    color: var(--accent-text);
    border: none;
    box-shadow: 0 8px 20px -8px color-mix(in srgb, var(--accent) 65%, transparent);
}
.btn-warning:hover:not(.disabled) {
    color: var(--accent-text);
    background-color: var(--accent-press);
    box-shadow: 0 12px 26px -8px color-mix(in srgb, var(--accent) 70%, transparent);
}
// disabled: ровно-серая, без тени (вместо saturate-фильтра)
.btn.disabled, .btn:disabled {
    background-color: #c9cbd4 !important;
    border-color: #c9cbd4 !important;
    color: #fff !important;
    box-shadow: none !important;
    cursor: not-allowed;
}

// --- secondary (Назад и пр.) ---
.btn-outline-warning {
    color: var(--ink);
    background-color: #fff;
    border: 1.5px solid var(--line-strong);
    box-shadow: none;
}
.btn-outline-warning:focus {
    color: var(--ink);
    background-color: #fff;
}
.btn-outline-warning:hover:not(.disabled) {
    color: var(--ink);
    background-color: #f7f7f9;
    border-color: #bcc0cc;
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
    background-color: #fff !important;
    border-color: var(--line) !important;
    color: var(--ink-faint) !important;
}
.btn-success {
    color: white;
    background-color: $color-green;
    border-color: $color-green;
}
.btn-success:hover:not(.disabled) {
    color: white;
    background-color: $color-green;

    filter: saturate(150%);
}
// .btn-success:focus {
//     color: $color-green;
//     background-color: white;
// }

.btn-outline-success {
    color: $color-green;
    background-color: white;
    border-color: $color-green;
}
.btn-outline-success:hover:not(.disabled) {
    color: white;
    background-color: $color-green;
}
.btn-outline-success:focus {
    color: white;
    background-color: $color-green;
}

.btn-outline-red {
    color: $color-warning;
    border-color: $color-warning;
}
.btn-outline-red:focus {
    color: $color-warning;
    background-color: white;
}
.btn-outline-red:hover:not(.disabled) {
    color: white;
    background-color: $color-warning;
    border-color: $color-warning;
}
.btn-href {
    color: white;
    background-color: $color-href;
    border-color: $color-href;
}
.btn-href:hover:not(.disabled) {
    color: white;
    background-color: $color-href;

    filter: saturate(150%);
}
.btn-outline-href {
    color: $color-href;
    border-color: $color-href;
}
.btn-outline-href:focus {
    color: $color-href;
    background-color: white;
}
.btn-outline-href:hover:not(.disabled) {
    color: white;
    background-color: $color-href;
    border-color: $color-href;
}

.btn-white-warning {
    color: white;
    background-color: $color-acent;
    border-color: white;
}
.btn-white-warning:hover:not(.disabled) {
    color: white;
    background-color: $color-acent;
    border-color: white;

    filter: saturate(150%);
}
.btn-outline-white-warning {
    color: $color-acent;
    background-color: white;
    border-color: $color-acent;
}
.btn-outline-white-warning:focus {
    color: white;
    background-color: $color-acent;
    border-color: white;
}
.btn-outline-white-warning:hover:not(.disabled) {
    color: white;
    background-color: $color-acent;
    border-color: white;
}

// карточки выбора (тип аккаунта в регистрации) — не CTA, высоту базового .btn сбрасываем
.btn-dashed, .btn-dashed:hover:not(.disabled)  {
    height: auto;
    border: 2px dashed #d6d4d4;
    border-radius: 30px;
}

.btn-dashed-active, .btn-dashed-active:hover:not(.disabled)  {
    height: auto;
    border: 2px solid $color-green;
    border-radius: 30px;
}
</style>
